import { useRef, React, useState } from "react";
import { useQuery } from "react-query";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Toolbar,
  ExcelExport,
  Group,
  Filter,
  Selection,
  Sort,
  Page,
} from "@syncfusion/ej2-react-grids";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import axios from "axios";
import {
  Box,
  CircularProgress,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import SideBar from "../sideBar/SideBar";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const ButtonStyle = styled.button`
  margin-top: 7px;
  width: 250px;
  height: 55px;
  background-color: #c7131c;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  border-color: #c7131c;
  border-radius: 5px;
  cursor: pointer;
`;
const ErrorText = styled.p`
  color: red;
`;

export default function ReportRunner() {
  const schema = yup.object().shape({
    runnerID: yup
      .number()
      .typeError("Runner is required")
      .required("Runner is required"),
    fromDate: yup.string().required("من تاريخ مطلوب"),
    toDate: yup.string().required("إلى تاريخ مطلوب"),
  });

  const [isLoading, setIsLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [showDataGrid, setShowDataGrid] = useState(false);

  // ✅ تشيك واحد لتثبيت التاريخين
  const [lockDates, setLockDates] = useState(false);

  const {
    handleSubmit,
    register,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
    defaultValues: {
      runnerID: "",
      fromDate: "",
      toDate: "",
    },
  });

  const navigate = useNavigate();
  const gridInstance = useRef(null);

  const handlePrint = () => {
    const printWindow = window.open("", "", "height=800,width=1200");
    const gridElement = gridInstance.current?.element;
    if (!printWindow || !gridElement) return;

    const tableHTML = gridElement.outerHTML;

    printWindow.document.write(`
    <html>
      <head>
        <title>طباعة التقرير</title>
        <style>
          body { margin:0; padding:0; font-family: Arial, sans-serif; }
          @page { size: A4 landscape; margin: 6mm; }
          .no-print, .e-toolbar, .e-toolbar-item, .e-groupdroparea { display: none !important; }
          #print-area { transform: scale(0.9); transform-origin: top left; width: 1180px; }
          @media print {
            body > *:not(#print-area) { display: none !important; }
            #print-area, #print-area .e-grid, #print-area .e-content {
              height: auto !important; max-height: none !important; overflow: visible !important;
            }
            #print-area .e-grid, #print-area .e-grid * { font-size: 11px !important; line-height: 1.1 !important; }
            #print-area .e-rowcell, #print-area .e-headercell { padding: 4px 6px !important; }
          }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #000; padding: 6px; text-align: center; }
          th { background:#f2f2f2; }
        </style>
      </head>
      <body>
        <div style="display:flex; justify-content:space-between; padding:8px 12px;">
          <div class="company-name" style="font-weight:bold;">Full Speed</div>
          <div class="report-name" style="font-weight:bold;">تقرير مناديب</div>
        </div>
        <div id="print-area">
          ${tableHTML}
        </div>
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const toolbarClick = (args) => {
    if (args.item.id === "grid_excelexport") {
      gridInstance.current?.excelExport();
    }
    if (args.item.id === "grid_print") {
      handlePrint();
    }
  };

  const accessToken = localStorage.getItem("userStorage")
    ? JSON.parse(localStorage.getItem("userStorage")).accessToken
    : null;

  const { data: runnerData } = useQuery(
    "runner_list",
    async () => {
      const data = await axios.post(
        "https://anydev.com-eg.net/api/RunnersActivity/V1/GetRunnersListEX/0",
        {
          pageSize: 10000,
          pageNumber: 1,
        },
        {
          headers: {
            CompanyID: "241701",
            AccessToken: `${accessToken}`,
          },
        }
      );
      return data.data.data;
    },
    {
      onError: (error) => {
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      },
    }
  );

  async function regeisterHandler(data) {
    const runnerSchema = { fromDate: "", toDate: "", runnerID: 0 };

    try {
      setIsLoading(true);

      // نحفَظ القيم الحاليّة للتواريخ قبل reset
      const { fromDate, toDate } = getValues();

      const response = await axios.post(
        "https://anydev.com-eg.net/api/RunnersActivity/V1/RunnerDays2DataDetails",
        { ...runnerSchema, ...data },
        { headers: { CompanyID: "241701", AccessToken: `${accessToken}` } }
      );

      reset(); // هنعيد القيم لو lockDates متعلم
      if (lockDates) {
        setValue("fromDate", fromDate);
        setValue("toDate", toDate);
      }

      setIsLoading(false);
      setResponseData(response.data.data);
      setShowDataGrid(true);
      return response.data.data;
    } catch (err) {
      console.error(err);
      setIsLoading(false);
      if (err.response && err.response.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  }

  const [selectedRunnerId, setSelectedRunnerId] = useState("");
  const [selectedRunnerCode, setSelectedRunnerCode] = useState("");

  const handleRunnerNameChange = (e) => {
    const runnerId = e.target.value;
    setSelectedRunnerId(runnerId);
    setValue("runnerID", +runnerId);

    if (runnerId === "0") {
      setSelectedRunnerCode("");
      return;
    }
    const selectedRunner = runnerData?.find(
      (runner) => runner.id === +runnerId
    );
    setSelectedRunnerCode(selectedRunner?.code || "");
  };

  const handleRunnerCodeChange = (e) => {
    const runnerCode = e.target.value;
    setSelectedRunnerCode(runnerCode);

    if (runnerCode === "0") {
      setSelectedRunnerId("0");
      setValue("runnerID", 0);
      return;
    }
    const selectedRunner = runnerData?.find(
      (runner) => runner.code === runnerCode
    );
    setSelectedRunnerId(selectedRunner?.id || "");
    setValue("runnerID", selectedRunner?.id || "");
  };

  const toolbarOptions = ["ExcelExport", "Print"];

  const onRowDataBound = (args) => {
    if (args.data.AssignedOrders < 10) {
      args.row.style.backgroundColor = "#ffe5e5";
    }
  };

  return (
    <div className="control-pane">
      <SideBar />

      {/* hidden input لربط runnerID بالفورم/الفاليديشن */}
      <input
        type="hidden"
        {...register("runnerID")}
        value={selectedRunnerId || ""}
        readOnly
      />

      <form onSubmit={handleSubmit(regeisterHandler)}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "15px",
            marginRight: "20px",
            flexWrap: "wrap",
            direction: "rtl",
          }}
        >
          {/* من تاريخ */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              label="من تاريخ"
              type="date"
              InputLabelProps={{ shrink: true }}
              sx={{ width: "250px" }}
              {...register("fromDate")}
            />
            <ErrorText>{errors.fromDate?.message}</ErrorText>
          </Box>

          {/* إلى تاريخ */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              label="إلى تاريخ"
              type="date"
              InputLabelProps={{ shrink: true }}
              sx={{ width: "250px" }}
              {...register("toDate")}
            />
            <ErrorText>{errors.toDate?.message}</ErrorText>
          </Box>

          {/* ✅ تشيك واحد لتثبيت (من/إلى) */}
          <Box sx={{ display: "flex", alignItems: "center", marginTop: "7px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={lockDates}
                  onChange={(e) => setLockDates(e.target.checked)}
                />
              }
              label="تثبيت (من / إلى)"
            />
          </Box>

          {/* المندوب بالاسم */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              select
              label="إختار المندوب بالاسم"
              sx={{ width: "250px" }}
              value={selectedRunnerId}
              onChange={handleRunnerNameChange}
            >
              <MenuItem value="0">الكل</MenuItem>
              {runnerData?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.arabicName}
                </MenuItem>
              ))}
            </TextField>
            <ErrorText>{errors.runnerID?.message}</ErrorText>
          </Box>

          {/* المندوب بالكود */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              select
              label="إختار المندوب بالكود"
              sx={{ width: "250px" }}
              value={selectedRunnerCode}
              onChange={handleRunnerCodeChange}
            >
              <MenuItem value="0">الكل</MenuItem>
              {runnerData?.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {item.code}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {/* أزرار */}
          <ButtonStyle type="submit">
            {isLoading ? <CircularProgress /> : `عرض البيانات`}
          </ButtonStyle>
          <ButtonStyle
            type="button"
            style={{ backgroundColor: "green", border: "1px solid green" }}
            className="no-print"
            onClick={handlePrint}
          >
            طباعة
          </ButtonStyle>
          <ButtonStyle
            type="button"
            className="no-print"
            style={{ backgroundColor: "#007bff", border: "1px solid #007bff" }}
            onClick={() => gridInstance.current?.excelExport()}
          >
            تصدير إلى Excel
          </ButtonStyle>
        </Box>
      </form>

      {showDataGrid && (
        <Box
          sx={{ height: 450, width: "98%", margin: "0 auto" }}
          className="col-lg-9 control-section"
        >
          <GridComponent
            dataSource={responseData}
            toolbar={toolbarOptions}
            ref={gridInstance}
            selectionSettings={{ type: "checkbox" }}
            filterSettings={{ type: "Excel" }}
            allowSorting
            allowExcelExport
            allowPdfExport
            enableStickyHeader
            allowFiltering
            allowGrouping
            toolbarClick={toolbarClick}
            rowDataBound={onRowDataBound}
          >
            <ColumnsDirective>
              <ColumnDirective width={40} type="checkbox" />
              <ColumnDirective
                headerText="السريال"
                field="runnerId"
                width="110"
                textAlign="Center"
              />
              <ColumnDirective
                headerText="التاريخ"
                field="dayDate"
                width="160"
                textAlign="Center"
                template={(props) => {
                  const date = new Date(props.dayDate);
                  const formattedDate = date.toLocaleDateString("en-CA"); // YYYY-MM-DD
                  return <span>{formattedDate}</span>;
                }}
              />
              <ColumnDirective
                headerText="المندوب"
                field="runnerName"
                width="130"
                textAlign="Center"
              />
              <ColumnDirective
                headerText="الفرع"
                field="branchNameA"
                width="130"
                textAlign="Center"
              />
              <ColumnDirective
                field="runningHours"
                headerText="ساعات العمل"
                width="150"
                textAlign="Center"
              />
              <ColumnDirective
                field="loans"
                headerText="السلف"
                width="120"
                textAlign="Center"
              />
              <ColumnDirective
                field="penalties"
                headerText="الجزاءات"
                width="120"
                textAlign="Center"
              />
              <ColumnDirective
                field="rewards"
                headerText="المكافأت"
                width="120"
                textAlign="Center"
              />
              <ColumnDirective
                field="assignedOrders"
                headerText="عدد الأوردرات"
                width="150"
                textAlign="Center"
              />
              <ColumnDirective
                field="calculatedSalary"
                headerText="الراتب"
                width="120"
                textAlign="Center"
              />
              <ColumnDirective
                field="notes"
                headerText="الملاحظات"
                width="180"
                textAlign="Center"
              />
            </ColumnsDirective>
            <Inject
              services={[
                Toolbar,
                ExcelExport,
                Group,
                Page,
                Filter,
                Selection,
                Sort,
              ]}
            />
          </GridComponent>
        </Box>
      )}
    </div>
  );
}
